import React, { useState } from "react";
import * as FormValidation from "../util/FormValidation";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Reload from "./common/Reload";
import ReactFlagsSelect from "react-flags-select";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { routeToPage } from "../util/RouteToPage";
import PagePath from "../util/RoutePagePath";
import "../style/checkout.scss";
import { currency } from "./common/Common";
import {
  RESTRICTED_COUNTRY_CODES,
  RESTRICTED_PHONE_COUNTRIES,
  RESTRICTION_MESSAGE,
  isRestrictedCountry,
} from "../util/TradeRestrictions";
import { BASE_URL } from "../constants/ApiEndpointConstants";
import { randomString } from "../util/createRandomOrderNo";
import Visa from "../icon/Visa";
import MasterCard from "../icon/MasterCard";
import American from "../icon/American";
import JCB from "../icon/JCB";

const Checkout = ({ items, onBack }) => {
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [country, setCountry] = useState("US");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [zip, setZip] = useState("");
  const [phone, setPhone] = useState("");
  const [phoneCountry, setPhoneCountry] = useState("US");
  const [tip, setTip] = useState("");
  const [isEmail, setIsEmail] = useState(false);
  const [, setIsFirstName] = useState(false);
  const [, setIsLastName] = useState(false);
  const [, setIsCountry] = useState(false);
  const [, setIsAddress] = useState(false);
  const [, setIsCity] = useState(false);
  const [, setIsZip] = useState(false);
  const [isPhone, setIsPhone] = useState(false);
  const [reloadingShow, setReloadingShow] = useState(false);

  const storedCartItems = useSelector((state) => state.cart.cartItems);
  const cartItems = items || storedCartItems;
  const cartTotal = cartItems.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0,
  );
  const shippingFee = cartItems.length ? 9.9 : 0;

  const navigate = useNavigate();

  const inputChange = (e, type) => {
    let telephone;
    switch (type) {
      case "email":
        setEmail(e.target.value);
        setTip("");
        break;
      case "firstName":
        setFirstName(e.target.value);
        setTip("");
        break;
      case "lastName":
        setLastName(e.target.value);
        setTip("");
        break;
      case "country":
        setCountry(e.target.value);
        setTip("");
        break;
      case "address":
        setAddress(e.target.value);
        setTip("");
        break;
      case "city":
        setCity(e.target.value);
        setTip("");
        break;
      case "zip":
        setZip(e.target.value);
        setTip("");
        break;
      case "phone":
        telephone = e.replace(/[-\s()]/g, "");
        setPhone(telephone);
        setTip("");
        break;

      default:
        break;
    }
  };

  const blurInput = (e, type) => {
    let reg;
    switch (type) {
      case "email":
        if (!FormValidation.isValidEmail(e.target.value)) {
          setIsEmail(true);
        } else {
          setIsEmail(false);
        }
        break;
      case "firstName":
        if (e.target.value.trim() === "") {
          setIsFirstName(true);
        } else {
          setIsFirstName(false);
        }
        break;
      case "lastName":
        if (e.target.value.trim() === "") {
          setIsLastName(true);
        } else {
          setIsLastName(false);
        }
        break;
      case "country":
        if (e.target.value.trim() === "") {
          setIsCountry(true);
        } else {
          setIsCountry(false);
        }
        break;
      case "city":
        if (e.target.value.trim() === "") {
          setIsCity(true);
        } else {
          setIsCity(false);
        }
        break;
      case "address":
        if (e.target.value.trim() === "") {
          setIsAddress(true);
        } else {
          setIsAddress(false);
        }
        break;
      case "zip":
        reg = /^[a-zA-Z0-9-_]{4,30}$/;
        if (!reg.test(e.target.value)) {
          setIsZip(true);
        } else {
          setIsZip(false);
        }
        break;
      case "phone":
        if (FormValidation.isValidPhoneNumber(e)) {
          setIsPhone(false);
        } else {
          setIsPhone(true);
        }
        break;
      default:
        break;
    }
  };

  const setSelected = (code) => {
    if (isRestrictedCountry(code)) {
      setTip(RESTRICTION_MESSAGE);
      return;
    }
    setCountry(code);
    setTip("");
  };

  const setPhoneValue = (value, data) => {
    const selectedPhoneCountry = String(data?.countryCode || "").toUpperCase();
    if (isRestrictedCountry(selectedPhoneCountry)) {
      setPhone("");
      setPhoneCountry("");
      setIsPhone(true);
      setTip(RESTRICTION_MESSAGE);
      return;
    }
    setPhoneCountry(selectedPhoneCountry);
    inputChange(value, "phone");
  };

  const clikctoPay = () => {
    if (isRestrictedCountry(country) || isRestrictedCountry(phoneCountry)) {
      return setTip(RESTRICTION_MESSAGE);
    }
    // let paymentVaild = paymentRef.current.getValid();
    // let { cardNumber, cvc, expiry } = paymentVaild;
    let fields = [email, firstName, lastName, address, zip, city];

    let next = fields.some((field) => (field || "").trim() !== "");

    if (!next) {
      return setTip("require");
    }
    if (isEmail) return setTip("please enter your email");
    if (isPhone) return setTip("please enter your phone number");
    let orderNo = randomString();
    let orderTotal = cartTotal + shippingFee;

    setReloadingShow(true);

    const timer = setTimeout(() => {
      const params = new URLSearchParams({
        orderNo: String(orderNo ?? ""),
        amount: String(orderTotal ?? ""),
        currency: currency === "$" ? "USD" : String(currency ?? ""),
        email: String(email ?? ""),
        success_url: `${BASE_URL}${PagePath.SUCCESS_PAGE}`,
        cancel_url: `${BASE_URL}${PagePath.HOME_PAGE}`,
        title: String(cartItems?.[0]?.title ?? ""),
      });

      const herfUrl = `${BASE_URL}/create_payment.php?${params.toString()}`;

      console.log("Payment URL:", herfUrl);

      window.location.href = herfUrl;
      clearTimeout(timer);
    }, 3000);
  };

  return (
    <React.Fragment>
      <Reload reloadingShow={reloadingShow} />
      <div className="min-h-screen text-[#1f1f1d]">
        <main>
          {/* =========================================================
        CHECKOUT HEADER
    ========================================================== */}
          <header className="border-b border-[#1f1f1d]/10 bg-white">
            <div className="mx-auto flex h-[72px] max-w-[1200px] items-center justify-between px-5 sm:px-8">
              <button
                type="button"
                onClick={() => onBack ? onBack() : routeToPage(navigate, PagePath.PRODUCT_PAGE)}
                className="text-[18px] font-medium tracking-[-0.02em]"
              >
                Checkout
              </button>

              <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.12em] text-black/45">
                <span>Cart</span>
                <span>→</span>
                <span className="text-black">Information</span>
                <span>→</span>
                <span>Payment</span>
              </div>
            </div>
          </header>

          {/* =========================================================
        CONTENT
    ========================================================== */}
          <div className="mx-auto grid max-w-[1200px] grid-cols-1 gap-8 px-5 py-8 sm:px-8 lg:grid-cols-[minmax(0,1fr)_400px] lg:gap-12 lg:py-12">
            {/* =======================================================
          LEFT — BILLING FORM
      ======================================================== */}
            <section className="min-w-0">
              <div className="bg-white px-5 py-7 sm:px-8 sm:py-9">
                {/* SECTION HEADER */}
                <div className="mb-8 border-b border-black/10 pb-6">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="mb-2 text-[9px] font-medium uppercase tracking-[0.12em] text-black/40">
                        Customer information
                      </p>

                      <h1 className="text-[24px] font-medium tracking-[-0.025em]">
                        Billing details
                      </h1>
                    </div>

                    <span className="hidden text-[9px] uppercase tracking-[0.12em] text-black/30 sm:block">
                      Step 1 of 2
                    </span>
                  </div>
                </div>

                <div className="space-y-7">
                  {/* =====================================================
                EMAIL
            ====================================================== */}
                  <div>
                    <label className="mb-2 block text-[12px] font-medium text-black/75">
                      Email address
                    </label>

                    <input
                      type="text"
                      placeholder="you@example.com"
                      onChange={(e) => inputChange(e, "email")}
                      onBlur={(e) => blurInput(e, "email")}
                      className="h-[50px] w-full border border-black/15 bg-white px-4 text-[14px] text-black outline-none transition-colors duration-200 placeholder:text-black/30 focus:border-black"
                    />

                    <p className="mt-2 text-[11px] leading-4 text-black/40">
                      We'll send your order confirmation to this email.
                    </p>
                  </div>

                  {/* =====================================================
                COUNTRY
            ====================================================== */}
                  <div>
                    <label className="mb-2 block text-[12px] font-medium text-black/75">
                      Country / region
                    </label>

                    <div className="checkout-select">
                      <ReactFlagsSelect
                        selected={country}
                        onSelect={(code) => setSelected(code)}
                        countries={RESTRICTED_COUNTRY_CODES}
                        blacklistCountries
                        searchable
                        searchPlaceholder="Search countries"
                      />
                    </div>

                    <p className="mt-2 text-[11px] leading-4 text-black/40">
                      Destinations restricted by our trade-compliance policy are
                      unavailable.
                    </p>
                  </div>

                  {/* =====================================================
                NAME
            ====================================================== */}
                  <div>
                    <label className="mb-2 block text-[12px] font-medium text-black/75">
                      Full name
                    </label>

                    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                      <div>
                        <input
                          type="text"
                          placeholder="First name"
                          onChange={(e) => inputChange(e, "firstName")}
                          onBlur={(e) => blurInput(e, "firstName")}
                          className="h-[50px] w-full border border-black/15 bg-white px-4 text-[14px] outline-none transition-colors duration-200 placeholder:text-black/30 focus:border-black"
                        />
                      </div>

                      <div>
                        <input
                          type="text"
                          placeholder="Last name"
                          onChange={(e) => inputChange(e, "lastName")}
                          onBlur={(e) => blurInput(e, "lastName")}
                          className="h-[50px] w-full border border-black/15 bg-white px-4 text-[14px] outline-none transition-colors duration-200 placeholder:text-black/30 focus:border-black"
                        />
                      </div>
                    </div>
                  </div>

                  {/* =====================================================
                ADDRESS
            ====================================================== */}
                  <div>
                    <label className="mb-2 block text-[12px] font-medium text-black/75">
                      Address
                    </label>

                    <input
                      type="text"
                      placeholder="Street address"
                      onChange={(e) => inputChange(e, "address")}
                      onBlur={(e) => blurInput(e, "address")}
                      className="h-[50px] w-full border border-black/15 bg-white px-4 text-[14px] outline-none transition-colors duration-200 placeholder:text-black/30 focus:border-black"
                    />
                  </div>

                  {/* =====================================================
                CITY / ZIP
            ====================================================== */}
                  <div>
                    <label className="mb-2 block text-[12px] font-medium text-black/75">
                      City and postal code
                    </label>

                    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                      <input
                        type="text"
                        placeholder="City"
                        onChange={(e) => inputChange(e, "city")}
                        onBlur={(e) => blurInput(e, "city")}
                        className="h-[50px] w-full border border-black/15 bg-white px-4 text-[14px] outline-none transition-colors duration-200 placeholder:text-black/30 focus:border-black"
                      />

                      <input
                        type="text"
                        placeholder="Postal code"
                        onChange={(e) => inputChange(e, "zip")}
                        onBlur={(e) => blurInput(e, "zip")}
                        className="h-[50px] w-full border border-black/15 bg-white px-4 text-[14px] outline-none transition-colors duration-200 placeholder:text-black/30 focus:border-black"
                      />
                    </div>
                  </div>

                  {/* =====================================================
                PHONE
            ====================================================== */}
                  <div>
                    <label className="mb-2 block text-[12px] font-medium text-black/75">
                      Phone number
                    </label>

                    <div className="h-[50px] border border-black/15 bg-white">
                      <PhoneInput
                        country={"us"}
                        value={phone}
                        onChange={setPhoneValue}
                        onBlur={() => blurInput(phone, "phone")}
                        excludeCountries={RESTRICTED_PHONE_COUNTRIES}
                        className="w-full"
                      />
                    </div>

                    <p className="mt-2 text-[11px] leading-4 text-black/40">
                      Used only if we need to contact you about your order.
                    </p>
                  </div>

                  {/* =====================================================
                PAYMENT
            ====================================================== */}
                  {/* <div>
              <div className="mb-3">
                <label className="block text-[12px] font-medium text-black/75">
                  Payment
                </label>

                <p className="mt-1 text-[11px] text-black/40">
                  All transactions are securely processed.
                </p>
              </div>

              <div className="border border-black/15 bg-white p-4">
                <Payment ref={paymentRef} />
              </div>
            </div> */}

                  {/* =====================================================
                ERROR MESSAGE
            ====================================================== */}
                  {tip && (
                    <div className="border border-red-200 bg-red-50 px-4 py-3">
                      <div className="flex items-start gap-3">
                        <span className="mt-[2px] text-[12px] text-red-500">
                          !
                        </span>

                        <p className="text-[12px] leading-5 text-red-600">
                          {tip}
                        </p>
                      </div>
                    </div>
                  )}

                  {/* =====================================================
                SUBMIT
            ====================================================== */}
                  <div className="border-t border-black/10 pt-7">
                    <button
                      type="button"
                      onClick={clikctoPay}
                      className="flex h-[56px] w-full items-center justify-between bg-[#1f1f1d] px-5 text-white transition-colors duration-200 hover:bg-[#353532] disabled:cursor-not-allowed disabled:opacity-40"
                    >
                      <span className="text-[11px] font-medium uppercase tracking-[0.14em]">
                        Complete payment
                      </span>

                      <span className="text-[18px] transition-transform duration-200">
                        →
                      </span>
                    </button>

                    <p className="mt-3 text-center text-[10px] leading-5 text-black/35">
                      By continuing, you agree to our shipping and return
                      policies.
                    </p>
                  </div>
                </div>
              </div>
            </section>

            {/* =======================================================
          RIGHT — ORDER SUMMARY
      ======================================================== */}
            <aside className="min-w-0 lg:sticky lg:top-6 lg:h-fit">
              <div className="border border-black/10 bg-white">
                {/* SUMMARY HEADER */}
                <div className="border-b border-black/10 px-5 py-5 sm:px-6">
                  <div className="flex items-center justify-between">
                    <h2 className="text-[17px] font-medium tracking-[-0.02em]">
                      Order summary
                    </h2>

                    <span className="text-[10px] uppercase tracking-[0.1em] text-black/40">
                      {cartItems.length}{" "}
                      {cartItems.length === 1 ? "item" : "items"}
                    </span>
                  </div>
                </div>

                {/* =====================================================
              ITEMS
          ====================================================== */}
                <div className="px-5 sm:px-6">
                  <div className="divide-y divide-black/10">
                    {cartItems.map((item) => (
                      <div key={item.id} className="flex gap-4 py-5">
                        {/* IMAGE */}
                        <div className="relative h-[72px] w-[72px] shrink-0 overflow-hidden bg-[#f3f3f0]">
                          <img
                            src={item?.images?.[0]}
                            alt={item.title}
                            className="h-full w-full object-cover"
                          />

                          <span className="absolute right-1.5 top-1.5 flex h-5 min-w-[20px] items-center justify-center bg-white px-1 text-[9px] font-medium">
                            {item.quantity}
                          </span>
                        </div>

                        {/* INFO */}
                        <div className="min-w-0 flex-1">
                          <h3 className="line-clamp-2 text-[13px] font-medium leading-5">
                            {item.title}
                          </h3>

                          {item?.variant && (
                            <p className="mt-1.5 text-[10px] text-black/40">
                              {item.variant}
                            </p>
                          )}

                          <p className="mt-2 text-[10px] uppercase tracking-[0.08em] text-black/35">
                            {item.category || "Product"}
                          </p>
                        </div>

                        {/* PRICE */}
                        <div className="shrink-0 text-right">
                          <p className="text-[13px] font-medium">
                            {currency}
                            {item?.price?.toFixed(2)}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* =====================================================
                TOTALS
            ====================================================== */}
                  <div className="border-t border-black/10 py-5">
                    <div className="space-y-3">
                      <div className="flex items-center justify-between">
                        <span className="text-[11px] text-black/50">
                          Subtotal
                        </span>

                        <span className="text-[12px]">
                          {currency}
                          {cartTotal.toFixed(2)}
                        </span>
                      </div>

                      <div className="flex items-center justify-between">
                        <span className="text-[11px] text-black/50">
                          Shipping
                        </span>

                        <span className="text-[12px]">
                          {currency}
                          {shippingFee.toFixed(2)}
                        </span>
                      </div>

                      <div className="flex items-center justify-between">
                        <span className="text-[11px] text-black/50">Taxes</span>

                        <span className="text-[11px] text-black/45">
                          Included
                        </span>
                      </div>
                    </div>

                    <div className="mt-5 border-t border-black/10 pt-5">
                      <div className="flex items-end justify-between">
                        <span className="text-[13px] font-medium">Total</span>

                        <span className="text-[24px] font-medium tracking-[-0.03em]">
                          <span className="mr-1 text-[13px]">{currency}</span>
                          {(cartTotal + shippingFee).toFixed(2)}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* =====================================================
              POLICY
          ====================================================== */}
                <div className="border-t border-black/10 bg-[#f8f8f6] px-5 py-5 sm:px-6">
                  <p className="text-[10px] leading-5 text-black/45">
                    By completing your purchase, you agree to our{" "}
                    <button
                      type="button"
                      onClick={() =>
                        routeToPage(navigate, PagePath.SHIPPING_PAGE)
                      }
                      className="text-black underline underline-offset-2"
                    >
                      shipping policy
                    </button>{" "}
                    and{" "}
                    <button
                      type="button"
                      onClick={() =>
                        routeToPage(navigate, PagePath.RETURN_PAGE)
                      }
                      className="text-black underline underline-offset-2"
                    >
                      return policy
                    </button>
                    .
                  </p>
                </div>

                {/* =====================================================
              PAYMENT METHODS
          ====================================================== */}
                <div className="border-t border-black/10 px-5 py-5 sm:px-6">
                  <div className="mb-3 flex items-center justify-between">
                    <span className="text-[9px] font-medium uppercase tracking-[0.12em] text-black/45">
                      Accepted payment methods
                    </span>
                  </div>

                  <div className="flex items-center gap-2">
                    <div className="flex h-[34px] w-[52px] items-center justify-center border border-black/10 bg-white">
                      <Visa size={42} />
                    </div>

                    <div className="flex h-[34px] w-[52px] items-center justify-center border border-black/10 bg-white">
                      <MasterCard size={42} />
                    </div>

                    <div className="flex h-[34px] w-[52px] items-center justify-center border border-black/10 bg-white">
                      <JCB size={42} />
                    </div>

                    <div className="flex h-[34px] w-[52px] items-center justify-center border border-black/10 bg-white">
                      <American size={42} />
                    </div>
                  </div>
                </div>
              </div>

              {/* SECURE CHECKOUT */}
              <div className="mt-4 flex items-center justify-center gap-2 text-[9px] uppercase tracking-[0.12em] text-black/35">
                <span className="text-[11px]">⌁</span>
                Secure checkout
              </div>
            </aside>
          </div>
        </main>
      </div>
    </React.Fragment>
  );
};

export default Checkout;
